import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Masthead from 'modules/Common/components/Masthead';
import MainHeader from 'modules/Common/components/MainHeader';
import HeaderActions from 'modules/Common/components/HeaderActions';
import CaretIcon from 'modules/Common/components/svg/CaretIcon';
import { Link } from 'react-router';
import { has } from 'utils/features';
import { getXsellUrl } from 'utils/commonUtils';
import { trackClick } from 'utils/AnalyticsUtils';
import { INSIDERS_LINK_CLICK_TRACKING_EVENT } from 'modules/Common/consts';
import { MetricsElement } from "react-metrics";
import { activeClassName } from 'utils/routeUtils';

class StickyMenu extends Component {
    static propTypes = {
        subnav: PropTypes.node,
        location: PropTypes.shape({
            pathname: PropTypes.string
        }).isRequired,
        loggedIn: PropTypes.bool,
        router: PropTypes.object.isRequired,
        featureClasses: PropTypes.array.isRequired,
        toggleMainMenu: PropTypes.func.isRequired,
        mainMenuOpen: PropTypes.bool,
        allSportsOpen: PropTypes.bool,
        subNavOpen: PropTypes.bool,
        subNavMoreOpen: PropTypes.bool,
        toggleSubNav: PropTypes.func.isRequired,
        toggleSubNavMore: PropTypes.func.isRequired,
        toggleAllSports: PropTypes.func.isRequired,
        navConfig: PropTypes.object.isRequired
    };

    static calculateScrollThreshold(maxScrollDiff, currentThreshold, scrollDiff) {
        const scrollThreshold = (currentThreshold + scrollDiff > maxScrollDiff) ? maxScrollDiff : currentThreshold + scrollDiff;

        return (scrollThreshold < 0) ? 0 : scrollThreshold;
    }

    componentWillReceiveProps() {
        this.watchScroll();
    }

    componentDidMount() {
        this.watchScroll();
    }

    componentWillUnmount() {
        this.unwatchScroll();
    }

    goBack() {
        if (window.history.length > 1) {
            window.history.back();
        }
    }

    isRoot() {
        return '/' === this.props.location.pathname;
    }

    mainNavLink(link) {
        return link.href &&
            <MetricsElement key={link.text} >
                <li className={link.className}>
                    <Link {...link.tracking} className={activeClassName(this.props.router, link, "nav-active")} to={link.href}>
                        {link.text}
                    </Link>
                </li>
            </MetricsElement>
    }

    handleScroll() {
        const stickyMenu = this.menu;

        const menuStyle = stickyMenu.style;
        const menuHeight = stickyMenu.getBoundingClientRect().height;
        let scrollThreshold = 0;
        let lastScroll = 0;

        return () => {
            const scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            const diff = scrollY - lastScroll;
            const maxScrollDiff = menuHeight * 2;

            scrollThreshold = StickyMenu.calculateScrollThreshold(maxScrollDiff, scrollThreshold, diff);

            if (scrollThreshold >= menuHeight && diff > 0) {
                scrollThreshold = maxScrollDiff;
            }

            menuStyle['top'] = `${-scrollThreshold}px`;
            lastScroll = scrollY;

            if (scrollThreshold >= menuHeight) {
                if (this.props.allSportsOpen) {
                    this.props.toggleAllSports(null, false);
                }
            }
        }
    }

    watchScroll() {
        document.addEventListener("scroll", this.handleScroll(), false);
    }

    unwatchScroll() {
        document.removeEventListener("scroll", this.handleScroll());
    }

    getHeaderActions(screenSize) {
        return <HeaderActions loggedIn={this.props.loggedIn} router={this.props.router} screenSize={screenSize} />;
    }

    render() {
      const { subnav, navConfig } = this.props;
      const LocalSubNav = subnav;

      const stickyMenuProps = {
        id: "stickyMenu"
      };

      if (has("integrated-betslip")) {
        stickyMenuProps.className = "integrated-betslip";
      }

      const mainNav = [
        {href: "/racing",                   text: "Racing", exceptions: [{href: "/racing/fast-results"}]},
        {href: "/racing/fast-results",      text: "Fast Results"},
        {href: "/football",                 text: "Football"},
        {href: "/news/rugby-world-cup/36",  text: "Rugby World Cup"},
        {href: "/greyhounds",               text: "Greyhounds"},
        {href: "/golf",                     text: "Golf"},
        {href: "/darts",                    text: "Darts", className: "tablet-shift"}
      ];
    //   const mainFestival = {href: navConfig.event.uri,    text: navConfig.event.title,   className: "tablet-shift"};
    //   if (navConfig.event.title){
    //     mainNav.splice(navConfig.event.mainNavIndex, 0, mainFestival);
    //   }

      const subNav = [
        {href: "/darts",        text: "Darts", className: "tablet-shift-more"},
        {href: "/tennis",       text: "Tennis"},
        {href: "/cricket",      text: "Cricket"},
        {href: "/boxing",       text: "Boxing / MMA"},
        {href: "/formula1",     text: "Formula 1"},
        {href: "/nfl",          text: "NFL"},
        {href: "/rugby-league", text: "Rugby League"},
        {href: "/rugby-union",  text: "Rugby Union"},
        {href: "/snooker",      text: "Snooker"},
        {href: "/other-sports", text: "Other Sports"}
      ];
    //   const subFestival = {href: navConfig.event.uri,   text: navConfig.event.title,   className: "tablet-shift-more"};
    //   if (navConfig.event.title){
    //     subNav.splice(navConfig.event.subNavIndex, 0, subFestival);
    //   }

      return(
            <div {...stickyMenuProps} ref={menu => this.menu = menu}>
                <section>
                    <Masthead />
                </section>
                <section>
                    <div id="header">
                        <MainHeader
                            path={this.props.location.pathname}
                            isLoggedIn={this.props.loggedIn}
                            featureStyleClasses={this.props.featureClasses}
                            backButtonAction={this.goBack}
                            toggleMenuAction={this.props.toggleMainMenu}
                            isMenuClosed={this.props.mainMenuOpen}
                        >
                            {this.getHeaderActions("desktop")}
                        </MainHeader>
                    </div>
                </section>
                <section>
                    <nav id="nav">
                        <div className={`nav-level1 ${!this.isRoot() ? 'nav-level1-with-back' : ''}`} onClick={e => this.props.toggleMainMenu(e, false)}>
                            <ul className={this.props.mainMenuOpen ? "open": ""}>
                                {
                                    mainNav.map(link => this.mainNavLink(link))
                                }
                                <li data-keep-menu-open className={`no-link allsports-nav${this.props.allSportsOpen ? " sub-open": ""}`} onClick={e => this.props.toggleAllSports(e)}>
                                    More<CaretIcon type="line" direction={`${this.props.allSportsOpen ? "left": "right"}`}/>
                                    <ul>
                                        {
                                            subNav.map(link => this.mainNavLink(link))
                                        }
                                    </ul>
                                </li>
                                <li><a href={getXsellUrl("https://m.skybet.com?aff=726&dcmp=SL_NAV_Main_SB_19")} target="_blank">Sky Bet</a></li>
                                <li className="pick-7-menu-item"><a href={getXsellUrl("https://itv7.itv.com/?dcmp=SL_Nav")} target="_blank">ITV7</a></li>
                                {has("insider-benefits") &&
                                    this.mainNavLink({
                                        href: "/insider",
                                        text: "Insiders",
                                        className: "tablet-shift new-flag",
                                        tracking: trackClick(INSIDERS_LINK_CLICK_TRACKING_EVENT, {link: "[Insiders] Nav Link"})
                                    })
                                }
                            </ul>
                        </div>
                    {this.getHeaderActions("mobile")}
                    {LocalSubNav &&
                        <LocalSubNav
                            open={this.props.subNavOpen}
                            opener={(...args) => this.props.toggleSubNav(...args)}
                            moreOpen={this.props.subNavMoreOpen}
                            moreOpener={(...args) => this.props.toggleSubNavMore(...args)}
                        />
                    }
                    </nav>
                </section>
            </div>
        );
    }
}

export default StickyMenu;



// WEBPACK FOOTER //
// ./modules/Common/components/StickyMenu.js